import React from "react";
import {
    Dialog,
    DialogContent,
    DialogTitle,
    Button,
    DialogActions,
    Typography,
    Box,
    List,
    ListItem,
    ListItemText,
} from "@mui/material";

interface WaivableErrorsDialogProps {
    isOpen: boolean;
    errors: string[];
    action: "Ingest" | "Validate" | "PVC Package" | "Roku Package" | "MDU Packages";
    onClose: () => void;
    onWaive: () => void;
}

const WaivableErrorsDialog: React.FC<WaivableErrorsDialogProps> = ({
    isOpen,
    errors,
    action,
    onClose,
    onWaive,
}) => {
    return (
        <Dialog open={isOpen} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>{action}</DialogTitle>
            <DialogContent>
                <Typography variant="subtitle1" sx={{ mt: 1, mb: 2 }}>
                    Please review the following errors before you proceed
                </Typography>
                <Box sx={{ mt: 2, mb: 2 }}>
                    <List>
                        {errors &&
                            errors.map((error: string, index: number) => (
                                <ListItem key={index} sx={{ px: 0 }}>
                                    <ListItemText
                                        primary={error}
                                        primaryTypographyProps={{
                                            component: "div",
                                            sx: { whiteSpace: "pre-wrap" },
                                        }}
                                    />
                                </ListItem>
                            ))}
                    </List>
                </Box>
                <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mt: 2, fontStyle: "italic" }}
                >
                    Continue to {action} doesn&apos;t guarantee successful
                    completion. Please check your artifacts
                </Typography>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button onClick={onClose} color="secondary">
                    Cancel
                </Button>
                <Button onClick={onWaive} color="primary" variant="contained">
                    Continue Anyway
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default WaivableErrorsDialog;
